import { render, staticRenderFns } from "./DashboardDesktop.vue?vue&type=template&id=234fd570&scoped=true&"
import script from "./DashboardDesktop.vue?vue&type=script&lang=js&"
export * from "./DashboardDesktop.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDesktop.vue?vue&type=style&index=0&id=234fd570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234fd570",
  null
  
)

export default component.exports